import { useState, useEffect } from 'react';
import { getPrivacyPolicyStatus } from '../services/privacyPolicyService';
import { userAppContext } from '../context/Context';

export const usePrivacyPolicy = () => {
  const [privacyPolicyAccepted, setPrivacyPolicyAccepted] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const { user, isAuthenticated } = userAppContext();

  const checkPrivacyPolicyStatus = async () => {
    const userId = user?.sub || user?.username;

    if (!isAuthenticated || !userId) {
      setPrivacyPolicyAccepted(null);
      setIsLoading(false);
      return;
    }

    try {
      setIsLoading(true);
      setError(null);
      const response = await getPrivacyPolicyStatus(userId);
      setPrivacyPolicyAccepted(response.privacyPolicyAccepted);
    } catch (err) {
      console.error('Error checking privacy policy status:', err);
      setError(err);
      setPrivacyPolicyAccepted(false);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const userId = user?.sub || user?.username;
    if (isAuthenticated && userId) {
      checkPrivacyPolicyStatus();
    } else {
      setPrivacyPolicyAccepted(null);
      setIsLoading(false);
    }
  }, [isAuthenticated, user?.sub, user?.username]);

  const refreshPrivacyPolicyStatus = () => {
    checkPrivacyPolicyStatus();
  };

  const markAsAccepted = () => {
    setPrivacyPolicyAccepted(true);
  };

  return {
    privacyPolicyAccepted,
    isLoading,
    error,
    refreshPrivacyPolicyStatus,
    markAsAccepted,
  };
};
